// extracted by mini-css-extract-plugin
export default {"input":"ApproveDispute_input__g1fRI"};